import MetadataDrivenCommon from './common/MetadataDrivenCommon';

class MetadataDrivenElement extends MetadataDrivenCommon {
    constructor(viewModel, pageDefinition, contentPath) {
        super(viewModel, pageDefinition, contentPath, 'element');
    }

    get content() {
        return this.presentationModel.content;
    }
}
export default MetadataDrivenElement;
